export type ModuleNavItem = {
  key: string;
  name?: string;
  title: string;
};

export type WorkspaceModule = {
  key: string;
  name: string;
  description: string;
  enabled: boolean;
  nav: ModuleNavItem[];
};

export type ModulesResponse = {
  account_id: number;
  products: string[];
  modules: WorkspaceModule[];
};

export function findModule(modules: WorkspaceModule[], key: string | undefined) {
  if (!key) return null;
  return modules.find((module) => module.key === key) ?? null;
}

/** 可按品牌开通的运营工具（不含知识库等基建） */
export const BRAND_OPERATING_TOOL_KEYS = ["aiso", "journey", "brand_site"] as const;

export function isBrandOperatingTool(key: string | null | undefined): boolean {
  if (!key) return false;
  return (BRAND_OPERATING_TOOL_KEYS as readonly string[]).includes(key);
}

/** 本品牌是否已开通某运营工具（BrandTool） */
export function brandHasTool(
  brand: { tools?: Array<{ product: string }> | null } | null | undefined,
  product: string | null | undefined,
): boolean {
  if (!brand || !product || !isBrandOperatingTool(product)) return false;
  return (brand.tools ?? []).some((tool) => tool.product === product);
}

/** 账户已订阅且本品牌已开通的运营工具（侧栏 / 切换器用；排除知识库基建） */
export function enabledBrandModules(
  modules: WorkspaceModule[],
  brand: { tools?: Array<{ product: string }> | null } | null | undefined,
): WorkspaceModule[] {
  return modules.filter(
    (app) => app.enabled && isBrandOperatingTool(app.key) && brandHasTool(brand, app.key),
  );
}

/** 产品默认深链 section：取 nav 首项（journey → overview；aiso → overview） */
export function defaultAppSection(module: WorkspaceModule | null | undefined): string {
  return module?.nav[0]?.key ?? "overview";
}
